import {useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {ArrowRight, ArrowUpRight, Layers3, UsersRound, ShieldCheck, LockKeyhole} from 'lucide-react';
import {useTranslation} from 'react-i18next';
import {Button} from './ui/button';
import {Eyebrow} from './Common';
import {ChequeSizeSlider} from './ChequeSizeSlider';
import {CHEQUE_SIZES} from '../lib/chequeSizes';
import './PreSeedInvestment.css';

const priorities = [
  [Layers3, 'product'], [UsersRound, 'customers'], [ShieldCheck, 'trust'],
];

export const PreSeedInvestment = () => {
  const {t} = useTranslation(); const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const copy = key => t(`preSeed.${key}`);
  function continueToForm(event) {
    event.preventDefault();
    const params = new URLSearchParams({amount: String(CHEQUE_SIZES[selectedIndex].amount)});
    navigate(`/invest?${params.toString()}`);
  }
  return <section className="preseed-section" id="pre-seed-investment" aria-labelledby="preseed-heading" data-testid="preseed-section">
    <div className="wrap preseed-layout"><div className="preseed-perspective">
      <Eyebrow id="preseed-eyebrow">{copy('eyebrow')}</Eyebrow>
      <h2 id="preseed-heading" className="editorial-heading" data-testid="preseed-title">{copy('title')}</h2>
      <p className="preseed-subtitle" data-testid="preseed-subtitle">{copy('subtitle')}</p>
      <p className="preseed-vision" data-testid="preseed-vision">{copy('vision')}</p>
      <h3 className="preseed-label" data-testid="preseed-priorities-title">{copy('prioritiesTitle')}</h3>
      <div className="preseed-priorities">{priorities.map(([Icon, key]) => <div className="preseed-priority" key={key}>
        <Icon size={21} strokeWidth={1.4} aria-hidden="true"/><div><h4 data-testid={`preseed-${key}-title`}>{copy(`${key}Title`)}</h4><p data-testid={`preseed-${key}-description`}>{copy(`${key}Body`)}</p></div>
      </div>)}</div>
      <p className="preseed-priorities-note" data-testid="preseed-priorities-note">{copy('prioritiesNote')}</p>
    </div>
    <form className="preseed-widget" onSubmit={continueToForm} noValidate data-testid="preseed-widget">
      <div className="preseed-widget-top"><Eyebrow id="preseed-widget-eyebrow">{copy('widgetEyebrow')}</Eyebrow><img src="/mahakali-logo.png" alt="Mahakali Tribunal" width="36" height="36" data-testid="preseed-logo"/></div>
      <h3 data-testid="preseed-widget-title">{copy('widgetTitle')}</h3>
      <p className="preseed-widget-description" data-testid="preseed-widget-description">{copy('widgetDescription')}</p>
      <ChequeSizeSlider selectedIndex={selectedIndex} onChange={setSelectedIndex}/>
      <Button type="submit" className="action preseed-continue" data-testid="preseed-continue">{copy('continue')}<ArrowUpRight size={16}/></Button>
      <p className="preseed-no-account" data-testid="preseed-no-account">{copy('noAccount')}</p>
      <div className="preseed-nonbinding"><ShieldCheck size={17} aria-hidden="true"/><p data-testid="preseed-nonbinding">{copy('nonbinding')}</p></div>
      <Link to="/governance" className="text-link preseed-risk" data-testid="preseed-risk-link">{copy('riskLink')}<ArrowUpRight size={14}/></Link>
      <Link to="/preseed" className="text-link preseed-overview-link" data-testid="homepage-preseed-overview">{copy('pageLink')} <ArrowUpRight size={14}/></Link>
    </form>
    <div className="preseed-review"><h3 className="preseed-label" data-testid="preseed-review-title">{copy('processTitle')}</h3><ol>{['step1','step2','step3'].map((step, index) => <li key={step}>
      <span className="preseed-step-number" aria-hidden="true">0{index+1}</span><span data-testid={`preseed-review-step-${index+1}`}>{copy(step)}</span>{index<2 && <ArrowRight size={15} aria-hidden="true"/>}
    </li>)}</ol></div>
    <div className="preseed-private-note"><LockKeyhole size={15} aria-hidden="true"/><p data-testid="preseed-private-note">{copy('privacyNote')}</p></div>
    </div>
  </section>;
};